ACC.globalmessages = {
    createGlobalMessage(globalMessageRequest, messageComponent, mainBlock) {
        fetch(`${ACC.config.encodedContextPath}/global-messages`, {
            dataType: 'html',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                CSRFToken: ACC.config.CSRFToken,
            },
            body: JSON.stringify(globalMessageRequest),
        })
            .then((response) => {
                if (response.redirected === true) {
                    window.location.reload();
                }
                return response.text();
            })
            .then((data) => {
                // eslint-disable-next-line no-undef
                const cleanData = DOMPurify.sanitize(data);
                const wrapper = $('<div class="global-alerts_wrap"></div>').append(cleanData);
                if (messageComponent && mainBlock) {
                    $(messageComponent).prepend(wrapper);
                    $(mainBlock).animate({ scrollTop: 0 }, 'fast');
                } else {
                    $('.main__inner-wrapper').prepend(wrapper);
                    $('html, body').animate({ scrollTop: 0 }, 'fast');
                }
                $('.closeAccAlert').on('click', function () {
                    $(this).parents('.global-alerts_wrap').remove();
                });
            });
    },

    removeGlobalMessages() {
        $('.closeAccAlert').click();
    },

    callErrorGlobalMessage(messageKey) {
        const globalMessageRequest = {
            globalMessages: [{
                messageHolder: 'accErrorMsgs',
                messages: [messageKey],
            }],
        };
        ACC.globalmessages.createGlobalMessage(globalMessageRequest);
    },
};
